import {Header,Footer} from "../../components/headerAndFooter"
import "../../components/normal.css"
import "./index.css"
import dayjs from "dayjs"
import {create} from "zustand"
import { useEffect } from "react"
import {fetchListApi,postListApi} from "../../apis/list"
import _ from "lodash"

const priority = {
  0: <div style={{ color: "red" }}>正事</div>,
  1: <div style={{ color: "green" }}>代办</div>,
  2: <div style={{ color: "#333" }}>不急</div>,
}
const createListStore = (set,get) => {
  return {
    list: [],
    addList:{
      text:"",
      date:"",
      priority:0,
    },
    setAddList: (payload) => set((state) => ({
      addList: {
        ...state.addList,
        ...payload
      }
    })),
    fetchList: async () => {
      const res = await fetchListApi()
      const newList = _.sortBy(res,["priority","date"])
      set({list:newList})
    },
    postList:async ()=>{
      set((state) => ({
        addList: {
          ...state.addList,
          date: dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss")
        }
      }))
      const state = get()
      const end = await postListApi(state.addList)
      alert(end)
      
      await get().fetchList()
      set((state)=>({
        addList: {
          text: "",
          date: "",
          priority: 0,
        }
      }))
    }

  }
}
const useStore = create((...a) => ({
  ...createListStore(...a),
}))

const Home = ()=>{
  const {list,addList,setAddList,fetchList,postList} = useStore()
  
  useEffect(() => { 
    fetchList()
  }, [])


  return <div>
    <Header />

    {/* 任务列表 */}
    {/* 有待添加的功能：1.点击选框，删除这条数据,2.axios获取数据，node从数据库获取数据 */}
    <div className="list">
      <div className="title">Task List</div>

      {/* 代办列表 */}
      <ul>
        {!list && alert("信息加载错误，没有获取到list")}
        {list?.map(item => <li key={item.id}>
          <div className="top">
            <div className="left">{item.text}</div>
            {priority[item.priority]}
          </div>
          <div className="bottom">{dayjs(item.date).format("YYYY-MM-DD HH:mm:ss")}</div>
        </li>)}
        {console.log(list)}
      </ul>

      {/* add list */}
      <div className="addList clearfix">
             
          <form>
          <span>添加任务：</span>
            <input type="text" className="input" value={addList.text} onChange={e=>setAddList({text:e.target.value})}></input>
            <label>正事<input type="radio" name="priority" value={0} checked={addList.priority==0} onChange={e=>setAddList({priority:Number(e.target.value)})}></input></label>
          <label>待办<input type="radio" name="priority" value={1} checked={addList.priority == 1} onChange={e => setAddList({ priority: Number(e.target.value) })}></input></label>
          <label>不急<input type="radio" name="priority" value={2} checked={addList.priority == 2} onChange={e => setAddList({ priority: Number(e.target.value) })}></input></label>

          <input type="button" value="提交" className="button" onClick={()=>postList()}/>
          </form>
        
      </div>
    </div>
    
    <Footer />
  </div>
}

export default Home